import { BaseModel, deepClone } from 'paliari-js-utils'

const attributes = {
  id: null,
  required: false,
  titulo: '',
  valor: (obj = {}) => obj,
  codigo: '',
  doc_id: null,
}

class DocItem extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
    this.valor = deepClone({ ...this.valor, required: obj.required })
  }
}

export default DocItem
